module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"unknownValidation":"Invalid field","required":"Required field","email":"A valid email is required","minLength":"It should contain at least {min} characters"},"de":{"unknownValidation":"Ungültiger Feldwert","required":"Pflichtfeld","email":"Eine gültige E-Mail ist erforderlich","minLength":"Es sollte mindestens {min} Zeichen enthalten"}}')
  delete Component.options._Ctor
}
